import { render, staticRenderFns } from "./admin-nav.vue?vue&type=template&id=6e6bde0e&scoped=true&"
import script from "./admin-nav.vue?vue&type=script&lang=js&"
export * from "./admin-nav.vue?vue&type=script&lang=js&"
import style0 from "./admin-nav.vue?vue&type=style&index=0&id=6e6bde0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6bde0e",
  null
  
)

export default component.exports